/**
 * @typedef {import('../types/education-facilities').EducationFacility} EducationFacility
 * @typedef {import('../types/health-facilities').HealthFacility} HealthFacility
 * @typedef {import('../components/search/FacilitySearchResults').FacilityRadioOption} FacilityRadioOption
 */

/**
 * Label and stored value, e.g. `"31955107 - UNIVERSITY OF HARTFORD, WEST HARTFORD, CT"`.
 * `submitTransformer`'s `getSchoolInfo` helper parses this format, so update both together.
 * @param {EducationFacility} facility
 * @returns {FacilityRadioOption}
 */
export function mapEducationResult(facility) {
  const { facilityCode, name, city, physicalState } = facility.attributes;
  const value = `${facilityCode} - ${name}, ${city}, ${physicalState}`;
  return { id: facilityCode, label: value, value };
}

/**
 * Display name, e.g. `"Michael E. DeBakey Department of Veterans Affairs Medical Center, Houston, TX 77030"`.
 * Also saved as `yourHealthFacilityName`.
 * @param {HealthFacility} facility
 * @returns {string}
 */
export function formatHealthFacilityName({ attributes }) {
  const { city, state, zip } = attributes.address?.physical ?? {};
  // ZIP+4 is shortened to 5 digits
  const stateZip = [state, zip?.split('-')[0]].filter(Boolean).join(' ');
  return [attributes.name, city, stateZip].filter(Boolean).join(', ');
}

/**
 * Value is the facility ID, which is what gets submitted
 * @param {HealthFacility} facility
 * @returns {FacilityRadioOption}
 */
export function mapHealthResult(facility) {
  return {
    id: facility.id,
    label: formatHealthFacilityName(facility),
    value: facility.id,
  };
}
